import { queryOptions } from "@tanstack/react-query";

import {
  FetchSessionMessagesResponse,
  FetchSessionsResponse
} from "@seneca/chatbot-service-types";
import { Expose } from "@seneca/small-utils-library";

import queryClient from "services/queryClient";

import { getSessionMessages, getSessions } from "./client";

const serviceName = "chatbot-service";

export function getSessionsQueryOptions(options?: {
  lastKey?: string;
  limit?: number;
  enabled?: boolean;
}) {
  return queryOptions<Expose<FetchSessionsResponse>>({
    queryKey: [serviceName, "sessions", options?.lastKey, options?.limit],
    queryFn: () => getSessions(options),
    enabled: options?.enabled,
    staleTime: Infinity
  });
}

const sessionMessagesCacheKey = (sessionId: string) => [
  serviceName,
  "session-messages",
  sessionId
];

export function getSessionMessagesQueryOptions({
  sessionId,
  enabled,
  staleTime
}: {
  sessionId: string;
  enabled?: boolean;
  staleTime?: number;
}) {
  return queryOptions<Expose<FetchSessionMessagesResponse>>({
    queryKey: sessionMessagesCacheKey(sessionId),
    queryFn: () => getSessionMessages(sessionId),
    enabled,
    staleTime: staleTime ?? Infinity
  });
}

export function getCachedSessionMessages(sessionId: string) {
  const cachedSessionData: FetchSessionMessagesResponse | undefined =
    queryClient.getQueryData(sessionMessagesCacheKey(sessionId));
  return cachedSessionData?.chatbotMessages;
}
